import React from "react";

import Link from "next/link";

import * as Breadcrumbs from "~/components/Breadcrumbs";
import { ArrowLeftIcon } from "~/components/icons/Arrow";

interface Props {
  nextVaspURL: string;
  previousVaspURL: string;
}

export default function VaspNavigationButtons({ nextVaspURL, previousVaspURL }: Props) {
  return (
    <Breadcrumbs.Container>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <Breadcrumbs.Item>
          <Link href={previousVaspURL} passHref>
            <Breadcrumbs.ItemContent>
              <Breadcrumbs.ItemContentIcon>
                <ArrowLeftIcon />
              </Breadcrumbs.ItemContentIcon>
              <Breadcrumbs.ItemContentText>Previous Vasp</Breadcrumbs.ItemContentText>
            </Breadcrumbs.ItemContent>
          </Link>
        </Breadcrumbs.Item>

        <Breadcrumbs.Item>
          <Link href={nextVaspURL} passHref>
            <Breadcrumbs.ItemContent>
              <Breadcrumbs.ItemContentText>Next Vasp</Breadcrumbs.ItemContentText>
              <Breadcrumbs.ItemContentIcon>
                <div style={{ transform: "rotate(180deg)" }}>
                  <ArrowLeftIcon />
                </div>
              </Breadcrumbs.ItemContentIcon>
            </Breadcrumbs.ItemContent>
          </Link>
        </Breadcrumbs.Item>
      </div>
    </Breadcrumbs.Container>
  );
}
